import { render, staticRenderFns } from "./ShiftEditorFinish.vue?vue&type=template&id=51528876&scoped=true&lang=pug&"
import script from "./ShiftEditorFinish.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorFinish.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorFinish.vue?vue&type=style&index=0&id=51528876&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51528876",
  null
  
)

export default component.exports